import React from 'react';
import { Box } from '@mui/material';
import ResetPasswordRequestForm from '../../components/AuthForms/ResetPasswordRequestForm';

/**
 * ResetPasswordRequest Page
 * Simple container page for password reset request functionality
 * Renders the ResetPasswordRequestForm component
 */
const ResetPasswordRequest: React.FC = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: 'calc(100vh - 120px)',
        p: 2.5,
      }}
    >
      <ResetPasswordRequestForm />
    </Box>
  );
};

export default ResetPasswordRequest;
